import { render } from "./CarteleraPage.vue?vue&type=template&id=28a28aba&scoped=true"
import script from "./CarteleraPage.vue?vue&type=script&lang=js"
export * from "./CarteleraPage.vue?vue&type=script&lang=js"

import "./CarteleraPage.vue?vue&type=style&index=0&id=28a28aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a28aba"]])

export default __exports__